export default function IconDocuments({color = "white", size = 24}) {
    return (
        <svg
            width={size + 1}
            height={size}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.5 12H15.5M9.5 16H15.5M17.5 21H7.5C6.39543 21 5.5 20.1046 5.5 19V5C5.5 3.89543 6.39543 3 7.5 3H13.0858C13.351 3 13.6054 3.10536 13.7929 3.29289L19.2071 8.70711C19.3946 8.89464 19.5 9.149 19.5 9.41421V19C19.5 20.1046 18.6046 21 17.5 21Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}